export default __webpack_public_path__ + "static/media/ply.8f3b7a54.svg";